module.exports = __webpack_public_path__ + "static/extras_bg2.d1282de7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/extras_bg2.jpg
// module id = 1349
// module chunks = 174994552580003 196563901955997